const BASE_API = import.meta.env.VITE_APP_API

export default BASE_API
